const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PREVIEW':
      return action.previewData;
    case 'EDIT_PREVIEW':
      return {...state, ...action.updates};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/preview.js